import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "If this is NSFW you should quit",
  "description": "",
  "published": "2012-07-24T00:00:00.000Z",
  "redirect_from": ["/blog/if-this-is-nsfw-you-should-quit/swizec/4877"],
  "categories": "Amanda Palmer, Kickstarter, Not safe for work, Uncategorized, video, YouTube",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/amanda-palmer-want-it-back.png",
        "alt": "Amanda Palmer, Want it Back",
        "title": "Amanda Palmer, Want it Back"
      }}></img></p>
    <p>{`Perhaps I'm too European, or just too young, but I really don't understand why half of my internets are "`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Not_safe_for_work",
        "title": "Not safe for work"
      }}>{`NSFW`}</a>{`" these days.`}</p>
    <p>{`To make matters worse, people have started doing it themselves. Completely voluntarily. They post some benign picture on twitter and attach #nsfw. You click on it and ... it's a lady in a bikini. Standing in a sort of risque pose.`}</p>
    <p>{`Seriously?`}</p>
    <p>{`Sure, I understand we'd prefer to keep some things away from children. And that some things are better kept out of the workplace. But just so you know, boys start thinking about boobs when they are 9 or 10 years old ... girls probably aren't falling far behind if at all.`}</p>
    <p>{`The usual "everyone" rating includes people under the age of 13. This gives us a population of humans who want to play with LEGO's just as much as they want to look at boobies, but telling them about sex and educating them properly is somehow forbade. God forbid they know how it all works rather than causing problems for everyone.`}</p>
    <p>{`Can't have that.`}</p>
    <p>{`Okay, we can all agree obscene sex stuff and violence has no place in front of children's eyes or at work. But we have `}<em parentName="p">{`got`}</em>{` to draw the line somewhere saner than `}<em parentName="p">{`"OMG I CAN SEE NIPZ!"`}</em>{`. There is `}<strong parentName="p">{`nothing`}</strong>{` wrong with seeing a naked person just standing there, doing nothing obscene. It's just beautiful.`}</p>
    <p>{`Although I guess most of the world is much better in this regard than the english speaking diaspora. For some reason.`}</p>
    <p>{`What really grinds my bones, though, is that the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/English_people",
        "title": "English people"
      }}>{`English diaspora`}</a>{` is forcing itself on everybody else. It's becoming increasingly difficult to watch a video on Youtube without being logged in. Simply because most of them are age restricted.`}</p>
    <p>{`Take Amanda Palmer for instance.`}</p>
    <lite-youtube {...{
      "videoid": "cZCadqQY-Lw",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Her latest video is a song about love and heartbreak and stuff. All very innocent and lovely. Nothing strange happens in the whole video, there is nothing obscene in the lyrics, there aren't even any `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Profanity",
        "title": "Profanity"
      }}>{`cuss words`}</a>{`. She doesn't even `}<em parentName="p">{`mention`}</em>{` sex or anything remotely like that.`}</p>
    <p>{`But she lays in bed. Naked. And thus the video is "NSFW". Because god forbid you see a nipple, or even a bush! Oh mai god!`}</p>
    <p>{`The first time I heard about the song was in the context of `}{`_`}{`"Oh hey, Amanda Palmer has a new video and song. Too bad it's NSFW" `}{`_`}{`That's just sad.`}</p>
    <p>{`Nothing bad will happen if you look at completely nonsexual boobs at work or anywhere! Promise!`}</p>
    <p>{`And if it does, you should quit anyway. Your boss is a dick.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bellasugar.com/Amanda-Palmers-Map-Tasmania-Attacks-Shaving-Body-Hair-13472328"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_14_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.bellasugar.com/Amanda-Palmers-Map-Tasmania-Attacks-Shaving-Body-Hair-13472328"
        }}>{`Amanda Palmer Just Says No to Shaving`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://boingboing.net/2012/07/10/amanda-palmers-awesome-stop.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_19_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://boingboing.net/2012/07/10/amanda-palmers-awesome-stop.html"
        }}>{`Amanda Palmer's awesome stop-motion music video `}{`[`}{`NSFW`}{`]`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://detroit.cbslocal.com/2012/06/19/kate-upton-for-gq-is-nsfw/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95265365_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://detroit.cbslocal.com/2012/06/19/kate-upton-for-gq-is-nsfw/"
        }}>{`Kate Upton For GQ Is NSFW`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bellasugar.com/Jennifer-Lawrence-Makeup-X-Men-First-Class-18939092"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_07_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.bellasugar.com/Jennifer-Lawrence-Makeup-X-Men-First-Class-18939092"
        }}>{`Potentially NSFW: See Jennifer Lawrence's Labor-Intensive X-Men Transformation`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0e0375e6-b3fa-41e8-bcdb-40cda3cb27de",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      